export default {
  // 统计卡片
  todayAlertCount: '今日预警数',
  scanCountAlert: '扫码次数预警',
  crossRegionAlert: '跨地区预警数',
  vsYesterday: '较昨天',
  // 搜索区
  qrcode: '二维码',
  qrcodePlaceholder: '请输入二维码编号',
  alertTime: '预警时间',
  startTime: '开始时间',
  endTime: '结束时间',
  alertType: '预警类型',
  alertTypePlaceholder: '请选择',
  alertStatus: '预警状态',
  alertStatusPlaceholder: '请选择',
  // 预警类型
  typeScanCount: '次数预警',
  typeCrossRegion: '跨地区预警',
  // 预警状态
  statusAlerting: '预警中',
  statusResolved: '已解除',
  statusDisabled: '已禁用',
  // 操作按钮
  export: '导出',
  // 表格列
  colQrcode: '二维码',
  colUserInfo: '用户信息',
  colProductInfo: '产品信息',
  colAlertRule: '预警规则',
  colAlertStatus: '预警状态',
  colAlertTime: '预警时间',
  colAction: '操作',
  // 操作列
  resolveAlert: '解除预警',
  disableQrcode: '禁用二维码',
  // 解除预警弹窗
  resolveTitle: '解除预警',
  resolveContent: '确定要解除该预警吗？',
  resolveRemark: '处理备注',
  resolveRemarkPlaceholder: '请输入处理备注（选填）',
  // 禁用二维码弹窗
  disableTitle: '禁用二维码',
  disableContent: '确定要禁用该二维码吗？禁用后扫码将提示无效。',
  disableReason: '禁用原因',
  disableReasonPlaceholder: '请输入禁用原因',
  disableReasonRequired: '请输入禁用原因',
  // 空状态
  emptyText: '暂无预警记录',
};
